module.exports = __webpack_public_path__ + "assets/img/passwordIcon.efb2bdc9.svg";